import { Injectable } from '@angular/core';
import { AddressModalComponent } from '../../components/modal/address-modal/address-modal.component';
import { IModalController } from '../interfaces/imodal-controller';
import { ModalController } from '../modal-controller/modal-controller.service';

@Injectable({
  providedIn: 'root'
})
export class AddressModalController implements IModalController {

  constructor(private modalController: ModalController) { }

  create( title:string, address: {
    address: [string, string?],
    city: string,
    state: string,
    country: string
  }) {
    this.modalController.create({
      title,
      content: {
        component: AddressModalComponent,
        props: address
      }
    });
  }
  
  present() {
    return this.modalController.present();
  }
}
